import UnavailabilityListScreen from './UnavailabilityListScreen';

export default {
  ReactComponent: UnavailabilityListScreen,
  bindings: {
    currentUser: '<',
    goToSet: '&',
    goToNewSet: '&',
    goToHistory: '&',
    srcUserId: '<',
    isHistory: '<',
    approveSet: '&',
    denySet: '&',
    canManage: '<',
  },
};
